import script from "./CountBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CountBox.vue?vue&type=script&setup=true&lang=js"

import "./CountBox.vue?vue&type=style&index=0&id=6bb2dc0a&lang=less&scoped=true"

import exportComponent from "C:\\Users\\11920\\Desktop\\vue_db\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6bb2dc0a"]])

export default __exports__